import { useTranslation, TextArea } from '@testsigma/atoms';

const TextareaWrapper = ({ onChange, errors, description, value }) => {
  const { t } = useTranslation();

  return (
    <>
      <TextArea
        id='description'
        wrapperClassName='w-full mt-5'
        inputClassName='!py-2 resize-none placeholder-secondary-300'
        rows={7}
        label={t('agent.report_agent_modal_label')}
        value={value}
        onChange={onChange}
        placeholder={t('agent.report_agent_modal_placeholder')}
        maxLength={500}
        isRequired
        hasError={!!errors.description}
        errorText={errors.description?.message}
      />

      {!errors.description && description?.length < 50 && (
        <p className='text-secondary-500 text-xxs mt-1'>
          {t('agent.min_char_required')}
        </p>
      )}
    </>
  );
};

export default TextareaWrapper;
